import { SITE_NAME, SITE_URL, SITE_TAGLINE, absoluteUrl } from './siteConfig';
import { getProjectCanonicalPath } from './projectPaths';
import { SOCIAL_LINKS } from '../data/social';

const SOCIAL_SAME_AS = SOCIAL_LINKS.map((link) => link.href);

export function buildPersonJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: SITE_NAME,
    url: SITE_URL,
    jobTitle: 'Creative Director & Designer',
    description: SITE_TAGLINE,
    sameAs: SOCIAL_SAME_AS,
  };
}

export function buildCreativeWorkJsonLd(project) {
  if (!project) return null;

  const url = absoluteUrl(getProjectCanonicalPath(project));
  const image = project.heroImage || project.media;

  return {
    '@context': 'https://schema.org',
    '@type': 'CreativeWork',
    name: project.title,
    headline: project.title,
    description: project.blurb || project.tagline || project.intro?.[0],
    url,
    image: image ? absoluteUrl(image) : undefined,
    dateCreated: project.year,
    creator: {
      '@type': 'Person',
      name: SITE_NAME,
      url: SITE_URL,
    },
    genre: project.category || project.discipline,
  };
}

export function buildCollectionPageJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: 'Work — Andrea Fagioli',
    description: 'Selected projects across visual production, information design and web development.',
    url: `${SITE_URL}/work`,
    isPartOf: {
      '@type': 'WebSite',
      name: SITE_NAME,
      url: SITE_URL,
    },
  };
}

export function buildWebSiteJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL,
    description: SITE_TAGLINE,
    publisher: {
      '@type': 'Person',
      name: SITE_NAME,
    },
  };
}
